const Columns = require('./Columns.jsx');
const Name = require('../utility/Name.jsx');
const NonBreakingContainer = require('../common/NonBreakingContainer.jsx');

const Blocks = [
    {
        id: 'nonBreakingContainer',
        component: NonBreakingContainer.V1.Component,
        config: {
            Block: NonBreakingContainer.V1.TypeConfig.panel.block(),
            Columns: NonBreakingContainer.V1.TypeConfig.panel.columns(),
            Style: NonBreakingContainer.V1.TypeConfig.panel.style()
        },
        display: 'Non-Breaking',
        image: '',
        type: 'container'
    },
    {
        id: 'columnsTwo',
        component: Columns.V1.Component,
        config: {
            Block: {
                label: 'Block Configuration',
                options: [
                    ...Columns.V1.TypeConfig.options.column(),
                    ...Columns.V1.TypeConfig.options.column({ number: 1 }, {}, { value: '50%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 2 }, {}, { value: '50%' }, {}, {}, {})
                ]
            },
            Header: {
                expanded: false,
                label: 'Header Properties',
                options: [
                    ...Columns.V1.TypeConfig.options.header(),
                    ...Columns.V1.TypeConfig.options.header({ number: 1 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 2 })
                ]
            },
            Columns: [[], []],
            Style: Columns.V1.TypeConfig.panel.style()
        },
        display: 'Two Columns',
        image: '',
        type: 'layout'
    },
    {
        id: 'columnsThree',
        component: Columns.V1.Component,
        config: {
            Block: {
                label: 'Block Configuration',
                options: [
                    ...Columns.V1.TypeConfig.options.column(),
                    ...Columns.V1.TypeConfig.options.column({ number: 1 }, {}, { value: '33.33%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 2 }, {}, { value: '33.33%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 3 }, {}, { value: '33.33%' }, {}, {}, {})
                ]
            },
            Header: {
                expanded: false,
                label: 'Header Properties',
                options: [
                    ...Columns.V1.TypeConfig.options.header(),
                    ...Columns.V1.TypeConfig.options.header({ number: 1 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 2 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 3 })
                ]
            },
            Columns: [[], [], []],
            Style: Columns.V1.TypeConfig.panel.style()
        },
        display: 'Three Columns',
        image: '',
        type: 'layout'
    },
    {
        id: 'columnsFour',
        component: Columns.V1.Component,
        config: {
            Block: {
                label: 'Block Configuration',
                options: [
                    ...Columns.V1.TypeConfig.options.column(),
                    ...Columns.V1.TypeConfig.options.column({ number: 1 }, {}, { value: '25%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 2 }, {}, { value: '25%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 3 }, {}, { value: '25%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 4 }, {}, { value: '25%' }, {}, {}, {})
                ]
            },
            Header: {
                expanded: false,
                label: 'Header Properties',
                options: [
                    ...Columns.V1.TypeConfig.options.header(),
                    ...Columns.V1.TypeConfig.options.header({ number: 1 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 2 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 3 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 4 })
                ]
            },
            Columns: [[], [], [], []],
            Style: Columns.V1.TypeConfig.panel.style()
        },
        display: 'Four Columns',
        image: '',
        type: 'layout'
    },
    {
        id: 'columnsFive',
        component: Columns.V1.Component,
        config: {
            Block: {
                label: 'Block Configuration',
                options: [
                    ...Columns.V1.TypeConfig.options.column(),
                    ...Columns.V1.TypeConfig.options.column({ number: 1 }, {}, { value: '20%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 2 }, {}, { value: '20%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 3 }, {}, { value: '20%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 4 }, {}, { value: '20%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 5 }, {}, { value: '20%' }, {}, {}, {})
                ]
            },
            Header: {
                expanded: false,
                label: 'Header Properties',
                options: [
                    ...Columns.V1.TypeConfig.options.header(),
                    ...Columns.V1.TypeConfig.options.header({ number: 1 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 2 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 3 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 4 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 5 })
                ]
            },
            Columns: [[], [], [], [], []],
            Style: Columns.V1.TypeConfig.panel.style()
        },
        display: 'Five Columns',
        image: '',
        type: 'layout'
    },
    {
        id: 'columnsSix',
        component: Columns.V1.Component,
        config: {
            Block: {
                label: 'Block Configuration',
                options: [
                    ...Columns.V1.TypeConfig.options.column(),
                    ...Columns.V1.TypeConfig.options.column({ number: 1 }, {}, { value: '16.67%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 2 }, {}, { value: '16.67%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 3 }, {}, { value: '16.67%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 4 }, {}, { value: '16.67%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 5 }, {}, { value: '16.67%' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column({ number: 6 }, {}, { value: '16.67%' }, {}, {}, {})
                ]
            },
            Header: {
                expanded: false,
                label: 'Header Properties',
                options: [
                    ...Columns.V1.TypeConfig.options.header(),
                    ...Columns.V1.TypeConfig.options.header({ number: 1 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 2 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 3 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 4 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 5 }),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.header({ number: 6 })
                ]
            },
            Columns: [[], [], [], [], [], []],
            Style: Columns.V1.TypeConfig.panel.style()
        },
        display: 'Six Columns',
        image: '',
        type: 'layout'
    }
];

const BlocksV2 = {
    get: (group, contentType) => {
        return [
            {
                id: Name.Block.Columns,
                component: Columns.V2.Component,
                config: {
                    Block: Columns.V2.TypeConfig.panel.block(contentType),
                    blocks: [[], []],
                    Style: Columns.V2.TypeConfig.panel.style()
                },
                dataBlockType: 'container',
                dataType: 'layout',
                display: 'Columns',
                group,
                image: 'columns.png'
            },
            {
                id: Name.Block.NonBreakingContainer,
                component: NonBreakingContainer.V2.Component,
                config: {
                    Block: NonBreakingContainer.V2.TypeConfig.panel.block(),
                    blocks: [[]],
                    Style: NonBreakingContainer.V2.TypeConfig.panel.style()
                },
                dataBlockType: 'container',
                dataType: 'layout',
                display: 'Non-Breaking',
                group,
                image: ''
            }
        ]
    }
}

module.exports = {
    Blocks,
    BlocksV2
};